/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';

	/**
	 * Module for Help Tiles component.
	 *
	 * @author Walid Ghazzo, Sreten Ancic
	 * @namespace Tc.Module
	 * @class SupportCommunityBox
	 * @extends Tc.Module
	 */

	Tc.Module.SupportCommunityBox = Tc.Module.extend({

		// typeAhead config
		numOfItems: 3,
		minNumOfChars: 3,
		typeAheadTimeoutInMs: 300,

		// component config
		keywordPlaceholder: '_keyword_',
		supportstripNA: 'NA',
		classLinks: '.links',
		defaultSeachKeyword: SCS.search.searchKeywordDefaultText,
		cachedResults: {},
		selector: '.showform.',

		// session
		ssoSession: false,
		sscSession: false,
		sscProfile: false,
		ssoRedirect: false,

		// session initializer
		ssoSessionInit: false,
		sscSessionInit: false,
		sscProfileInit: false,

		// api handling
		sscApiURL: '//community.swisscom.ch/scs/restapi',
		sscApiPostSubject: "",
		sscApiPostContent: "",
		sscApiPostError: false,
		sscApiPostErrorMessage: false,
		sscApiUserID: "",
		sscApiFeedBack: {},
		sscBoardID: '',

		// error handling
		showForm: false,
		formError: false,
		formErrorPostSubject: false,
		formErrorPostContent: false,

		// i18n strings
		i18n: {},

		// other local variables
		jqXHR: {},
		typeAheadTimeoutId: null,

		/**
		 * hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$link = $ctx.find(mod.classLinks),
				i18n = $ctx.find('.i18n');

			mod.sscApiFeedBack = $ctx.find('.apifeedback');
			mod.i18n = i18n.data();

			require('lib/personalization/profile').getProfile().then(function(profile) {
				mod.user = profile.getUser();
				mod.initClientSessions();
				mod.loadDefault($link);
				mod.makeItSearchable($link);
				mod.getRedirectSelector();
			});
			

			callback();
		},

		loadDefault: function($link) {
			//$('#searchKeywordDefaultText') not exists in DOM !!!!
			var keyword = encodeURI($('#search').val()),
				defaultKeyword = encodeURI($('#searchKeywordDefaultText').data('value'));

			this.loadSupportStrip($link, keyword, defaultKeyword);
		},

		loadSupportStrip: function($link, keyword, defaultKeyword, callback) {
			var url = $link.data('url'),
				currentPagePath = $link.data('currentpagepath'),
				parsedUrl = this.getUrl(url, keyword, defaultKeyword);

			if (parsedUrl != undefined) {
				this.loadFromUrl($link, parsedUrl, currentPagePath, callback);
			}
		},

		makeItSearchable: function($link) {
			var mod = this;
			if ($link.data('search-enabled')) {
				var url = $link.data('url'),
					$ctx = mod.$ctx,
					$input = $ctx.find('#questionsubject');
				mod.bindSearch($input, $link);
			}
		},

		bindSearch: function($input, $link) {
			var mod = this,
				oldValue = "";

			$input.on('change keyup input', function() {
				var value = $input.val();

				if (value != oldValue) {
					oldValue = value;

					clearTimeout(mod.typeAheadTimeoutId);

					if (value.length == 0) {
						mod.loadDefault($link);
					} else {
						mod.typeAheadTimeoutId = setTimeout(function () {
							if (value.length >= mod.minNumOfChars) {
								mod.loadSupportStrip($link, value, '');
							} else {
								$link.html(mod.i18n.minChars.replace('{i}', mod.minNumOfChars));
							}
						}, mod.typeAheadTimeoutInMs);
					}
				}
			});
		},

		getUrl: function(url, keyword, defaultKeyword) {
			var mod = this;

			if (url.indexOf(mod.keywordPlaceholder)!==-1) {
				if (keyword == mod.defaultSeachKeyword || keyword == '' || keyword == defaultKeyword) {
					keyword = mod.supportstripNA;
				}
				url = url.replace(mod.keywordPlaceholder, $.base64.encode(keyword).replace('=', ''));
			}
			return url;
		},

		loadFromUrl: function($link, url, currentPagePath, callback) {
			var mod = this;

			// kill the previous AJAX call
			if (mod.jqXHR && mod.jqXHR.abort) {
				mod.jqXHR.abort();
			}

			if (mod.cachedResults[url]) {
				$link.html(mod.cachedResults[url]);
				if (callback) {
					callback(mod.cachedResults[url]);
				}
			} else {
				$link.html(mod.i18n.searching);
				mod.jqXHR = $.get(url, {tagSrc:currentPagePath}, function(response, status) {
					$link.html(response);
					if (status != 'success' && status != 'notmodified') {
						$link.hide();
					} else {
						mod.cachedResults[url] = response;
						if (callback) {
							callback(response);
						}
					}
				});
			}
		},

		initClientSessions: function() {
			var mod = this;
			mod.ssoSessionCheck();
			mod.sscSessionCheck();
			mod.sscProfileCheck();
		},

// check session: swisscom sso portal ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		ssoSessionCheck: function() {
			var mod = this;

			// check if user has active session in portal
			if (mod.user) {
				mod.ssoSession = true;
				debug.log('Tc.Module.SupportCommunityBox.js > ssoSessionCheck:SSO header logged in');
			}

			mod.ssoSessionInit = true;
			mod.sessionCallback();
		},

// check session: support community ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sscSessionCheck: function() {
			var mod = this;

			$.ajax({
				url: mod.sscApiURL + '/vc/authentication/sessions/login?restapi.response_format=json',
				dataType: 'json',
				success: function(data){
					mod.sscSessionInit = true;

					if (data.response.status == 'success'){
						mod.sscSession = true;
					}
					else if (data.response.status == 'error') {
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.code);
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.message);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > API error');
					}

					debug.log('Tc.Module.SupportCommunityBox.js > sscSessionCheck:SC-API session status: ' + data.response.status);
					mod.sessionCallback();
				},
				error: function(data){
					mod.sscSessionInit = true;
					debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.status);
					mod.sessionCallback();
				}
			});
		},

// check profile: support community ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sscProfileCheck: function() {
			var mod = this;

			$.ajax({
				url: mod.sscApiURL + '/vc/authentication/sessions/current/user?restapi.response_format=json',
				dataType: 'json',
				success: function(data){
					mod.sscProfileInit = true;

					if(data.response.status == 'success' && data.response.user.email != undefined){
						if (data.response.user.email.$ != '') {
							mod.sscProfile = true;
							mod.sscApiUserID = data.response.user.id.$;
							debug.log('Tc.Module.SupportCommunityBox.js > sscProfileCheck:SC-API profile email: ' + data.response.user.email.$);
						}
					}
					else {
						mod.sessionCallback();
					}
					mod.sessionCallback();
				},
				error: function(){
					// api not accessible
					mod.injectMessage(mod.i18n.technicalError, 'formerror', true);
					mod.sscProfileInit = true;
					mod.sessionCallback();
				}
			});
		},

// session callback ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sessionCallback: function() {
			var mod = this;

			if (mod.ssoSessionInit && mod.sscSessionInit && mod.sscProfileInit) {
				if (mod.ssoSession && mod.sscSession && mod.sscProfile && mod.ssoRedirect) {
					mod.showForm = true;
					mod.gotoForm();
				} else if (mod.ssoSession && mod.sscSession && !mod.sscProfile) {
					// no profile
				}				
				else {
					// no session available - sso issues?
					// mod.injectMessage(mod.i18n.technicalError, 'formerror', true);
				}
			}

			debug.log('Tc.Module.SupportCommunityBox.js > sso portal session: ' + mod.ssoSession);
			debug.log('Tc.Module.SupportCommunityBox.js > sso portal redirect: ' + mod.ssoRedirect);
			debug.log('Tc.Module.SupportCommunityBox.js > sc community session: ' + mod.sscSession);
			debug.log('Tc.Module.SupportCommunityBox.js > sc community profile: ' + mod.sscProfile);
			debug.log('Tc.Module.SupportCommunityBox.js > sc show form: ' + mod.showForm);
		},

		gotoForm: function() {
			var mod = this,
				$ctx = mod.$ctx,
				step = $ctx.find('.scs-support-strip-help');

			if (mod.showForm) {
				step.removeClass('step1').addClass('step2');
				$('.noAnswerButton').click(function (e) {
					e.preventDefault();
					mod.validateQuestionForm();
				})
			}
			else {
				step.removeClass('step2').addClass('step1');
			}
		},

// check redirect selector ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		getRedirectSelector: function() {
			var mod = this,
				currentURL = location.href;
				mod.ssoRedirect = currentURL.indexOf(mod.selector) != -1;

			debug.log('Tc.Module.SupportCommunityBox.js > getRedirectSelector: ' + mod.selector + ' : ' + mod.ssoRedirect);
			return mod.ssoRedirect;
		},

// validate form ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		validateQuestionForm: function() {
			var mod = this;

			mod.sscApiPostSubject = $('#questionsubject').val();
			mod.sscApiPostContent = $('#questioncontent').val();

			mod.formErrorPostSubject = ($.trim(mod.sscApiPostSubject) == "");
			mod.formErrorPostContent = ($.trim(mod.sscApiPostContent) == "");

			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.sscApiPostSubject: ' + mod.sscApiPostSubject);
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.sscApiPostContent: ' + mod.sscApiPostContent);

			if (mod.formErrorPostSubject || mod.formErrorPostContent) {
				mod.formError = true;
				mod.updateDisplayErrors();
			}
			else {
				mod.formError = false;
				mod.updateDisplayErrors();
				mod.submitQuestionForm();
			}
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formError: ' + mod.formError,'color: red');
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formErrorPostSubject: ' + mod.formErrorPostSubject);
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formErrorPostContent: ' + mod.formErrorPostContent);
		},

// show & hide errors based on validation ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		updateDisplayErrors: function() {
			var mod = this,
				$ctx = mod.$ctx,
				feqs = $ctx.find('.formerror.questionsubject'),
				feqc = $ctx.find('.formerror.questioncontent');

			mod.formErrorPostSubject ? feqs.removeClass('hidden') : feqs.addClass('hidden');
			mod.formErrorPostContent ? feqc.removeClass('hidden') : feqc.addClass('hidden');
		},


// inject messages (non-form) ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		injectMessage: function(message, cssclass, hideanswerbutton) {
			var mod = this,
				$ctx = mod.$ctx,
				button = $ctx.find('.noanswer');

			message					 = arguments[0] || "";
			cssclass					= arguments[1] || null;
			hideanswerbutton	= arguments[2] || false;

			mod.sscApiFeedBack.removeClass('hidden');

			if (hideanswerbutton) {
				button.hide();
			}

			if (cssclass !== null) {
				mod.sscApiFeedBack.removeClass();
				mod.sscApiFeedBack.addClass('apifeedback');
				mod.sscApiFeedBack.addClass(cssclass);
			}
			mod.sscApiFeedBack.html(message);
		},

// prepare api-request and submit ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		submitQuestionForm: function() {
			var mod = this,
				$ctx = mod.$ctx;
				mod.sscBoardID = $ctx.find('.modScForm').data('sscboardid');

			$.ajax({
				url: mod.sscApiURL + '/vc/boards/id/' + mod.sscBoardID +'/messages/post/',
				dataType: 'json',
				data: {
					'message.subject': mod.sscApiPostSubject,
					'message.body': mod.sscApiPostContent,
					'message.author': '/users/id/' + mod.sscApiUserID,
					'restapi.response_format': 'json'
				},

				success: function(data){
					mod.sscProfileInit = true;
					if (data.response.status == 'success'){
						debug.log('Tc.Module.SupportCommunityBox.js > Success');
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response);
						mod.confirmApiPost(data.response.message.id.$);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.message);
						mod.sscApiPostError = true;
						mod.sscApiPostErrorMessage = data.response.error.message;
						mod.sscApiFeedBack.addClass('formerror');
						mod.injectMessage('API error: ' + mod.sscApiPostErrorMessage);
					}
				},
				error: function(){
					mod.sscApiFeedBack.addClass('formerror');
					mod.injectMessage('API error');
				}
			});
		},

// prepare api-request and submit ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		confirmApiPost: function(id) {
			var mod = this,
				$ctx = mod.$ctx,
				form = $ctx.find('.modScForm'),
				button = $ctx.find('.noanswer');

			$.ajax({
				url: mod.sscApiURL + '/vc/messages/id/' + id + '/web_page_url',
				dataType: 'json',
				data: {
					'restapi.response_format': 'json'
				},

				success: function(data){
					if (data.response.status == 'success'){
						debug.log('Tc.Module.SupportCommunityBox.js > Success');
						form.hide();
						button.hide();
						mod.sscApiFeedBack.addClass('success');
						mod.injectMessage(mod.i18n.postSuccessMessage, 'success', true);
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.string.$);

						setTimeout(function(){
							location.href = data.response.string.$;
						},3000);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > Error' + data.response.error.message);
						// mod.sscApiPostError = true;
						// mod.sscApiPostErrorMessage = data.response.error.message;
					}
				},

				error: function(){
					debug.log('Tc.Module.SupportCommunityBox.js > API Error');
					debug.log('Tc.Module.SupportCommunityBox.js > ' + this.url);
				}
			});
		}
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.SupportCommunityBox.js
// module id = 356
// module chunks = 0